import { get, post } from '@/util'

/**
 * 登录云渲染
 * @param {*} url
 * @param {*} query
 * @param {*} option
 */
export async function renderCloudLogin(url, query, option = { perfect: true }) {
  const data = await post(url, query, { ...option });
  return data;
}

/**
 * 获取云渲染url
 * @param {*} url
 * @param {*} query
 * @param {*} option
 */
export async function renderCloudUrl(url, query, option = { perfect: true }) {
  const data = await post(url, query, { ...option });
  return data;
}
